import React from 'react'
import "./portfolio.css"
import IMG1 from "../../assets/portfolio1.jpg"
import IMG2 from "../../assets/portfolio2.jpg"
import IMG3 from "../../assets/portfolio3.jpg"
import IMG4 from "../../assets/portfolio4.jpg"
import IMG5 from "../../assets/portfolio5.jpg"
import IMG6 from "../../assets/portfolio6.jpg"

const data = [
  {
    id:1,
    image:IMG1,
    title: "Car Rental Landing Page - Responsive",
    link: "https://zen-jang-7df053.netlify.app/"
  },
  {
    id:2,
    image:IMG2,
    title: "AI Website - Responsive",
    link:"https://statuesque-maamoul-26aa54.netlify.app/"
  },
  {
    id:3,
    image:IMG3,
    title: "Blog - Responsive",
    link:"https://darling-maamoul-3aa00f.netlify.app/"
  },
  {
    id:4,
    image:IMG4,
    title: "Property Listing - Desktop Version",
    link:"https://eloquent-cheesecake-32eef8.netlify.app/"
  },
  {
    id:5,
    image:IMG5,
    title: "IV Therap Lounge - Responsive",
    link:"https://cocky-haibt-fc342d.netlify.app/"
  },
  
]

const Portfolio = () => {
  return (
    <section id='portfolio'>
      <h5>My Recent Work</h5>
      <h2>Portfolio</h2>

      <div className="container portfolio__container">
        {
          data.map(({id,image,title,link})=>{
            return(
              <article key={id} className='portfolio__item'>
                <div className="portfolio__item-image">
                  <img src={image} alt={title} />
                </div>
                <h3>{title}</h3>
                <div className="portfolio__item-cta">
                  <a href={link} target="_blank" className='btn'>view site</a>
                </div>
              </article> 
            )
          })
        }      
      </div>
    </section>
  )
}

export default Portfolio